<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'storedPhoto')">
            <div class="stored-photo">
                <a-alert s message="除系统分组【未分组】外，其余分组将按照相册顺序在售票小程序门店设施和门店相册模块进行展示（拖拽相册可进行排序）" banner />
                <div class="mt24 mb24">
                    <a-button type="primary" @click="$refs.addPhoto.open()">上传图片</a-button>
                    <a-button @click="$refs.addAlbum.open({})">创建相册</a-button>
                </div>

                <draggable
                    class="syllable_ul"
                    element="section"
                    filter=".none_group"
                    :list="list"
                    :options="{group:'title', animation:150}"
                    :no-transition-on-drag="true"
                    :forceFallback="true"
                    @end="changeEnd"
                >
                    <transition-group class="stored-photo-list">
                        <div class="item" :class="item.id == -1 ? 'none_group' : ''" v-for="item in list" :key="item.id">
                            <span v-if="item.isEquipment" class="item-sheshi">设施<span></span></span>
                            <img
                            class="item-img"
                            alt="暂无图片"
                            :src="item.coverUrl || require('../../assets/image/none_img.jpg')"
                            @click="toGroupPhoto(item.id)"
                            />
                            <div class="item-name">{{item.name}}</div>
                            <div class="item-op" v-if="item.id != -1">
                                <span class="item-tip">
                                    <a-icon type="down" />
                                </span>
                                <div class="item-op-list">
                                    <div @click="$refs.addAlbum.open(item)"><a-icon type="edit" /> 编辑</div>
                                    <div @click="showDelete(item.id)"><a-icon type="delete" /> 删除</div>
                                </div>
                            </div>
                            <span class="item-num">{{item.resourceCount || 0}}</span>
                        </div>
                    </transition-group>
                </draggable>
                <a-modal v-model="showDeleteModal" @ok="deleteAlumb" @cancel="cancelDelete" centered>
                    <a-radio-group v-model="deleteResource">
                        <a-radio :style="radioStyle" :value="false">
                            删除相册，相册内所有图片移到未分组
                        </a-radio>
                        <a-radio :style="radioStyle" :value="true">
                            删除相册，同时删除相册内所有图片
                        </a-radio>
                    </a-radio-group>
                </a-modal>
                <add-album ref="addAlbum" @cancel="getList"></add-album>
                <add-photo ref="addPhoto" @cancel="getList" :list="list"></add-photo>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script>
    import addAlbum from '@/components/modules/stored-photo/add-album.component';
    import addPhoto from '@/components/modules/stored-photo/add-photo.component';
    import draggable from 'vuedraggable';
    import { mapGetters } from "vuex";
export default {
    name: 'storedPhoto',
    components: {
        addAlbum,
        addPhoto,
        draggable
    },
    data() {
        return {
            form: this.$form.createForm(this),
            list: [],
            currentShopId: this.$route.params.id,
            showDeleteModal: false,
            deleteResource: false,
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
            },
            id: '',

        }
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    methods: {
        getList() {
            this.$api.storedPhoto.getAlbum({
                query: {
                    shopId: this.currentShopId
                }
            }).then(res => {
                this.list = res;
            });
        },
        changeEnd(e) {
            if(e.newIndex > 0) {
                let idList = [];
                this.list.forEach(item => {
                    idList.push(item.id)
                })
                this.$api.storedPhoto.batchOrder({
                    body: {
                        idList: idList
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getList();
                });
            }else {
                this.getList();
            }
        },
        showDelete(id) {
            this.showDeleteModal = true;
            this.id = id
        },
        deleteAlumb() {
            this.$api.storedPhoto.deleteAlbum({
                body: {
                    deleteResource: this.deleteResource,
                    id: this.id
                }
            }).then(res => {
                this.showDeleteModal = false;
                this.$message.success('操作成功');
                this.getList();
            });
        },
        cancelDelete() {
            this.showDeleteAlumb = false;
            this.deleteResource = false;
        },
        toGroupPhoto(id) {
            this.$router.push({name: 'groupPhoto', query: {id: id}})
        }
    },
    mounted() {
        this.getList()
    },
    watch: {
        $route(val) {
            val.name == 'storedPhoto' && this.getList()
        },
        shopId(val) {
            this.currentShopId = val;
            this.getList()
        }
    }
}
</script>
<style scoped lang="scss">
.stored-photo {
    background-color: #fff;
    padding: 24px 0 24px 24px;
    .ant-alert {
        margin-right: 24px;
    }
    &-list {
        display: flex;
        flex-wrap: wrap;
        .item {
            margin-right: 16px;
            margin-bottom: 16px;
            padding: 8px;
            border: 1px solid #e8e8e8;
            position: relative;
            .item-sheshi {
                position: absolute;
                left: -1px;
                top: -1px;
                z-index: 10;
                width: 36px;
                height: 25px;
                padding: 4px 4px 0;
                text-align: center;
                font-size: 14px;
                white-space: nowrap;
                color: #FFF;
                cursor: pointer;
                background-color: #fdcd52;
                >span {
                    position: absolute;
                    z-index: -1;
                    top: 20px;
                    left: 0;
                    border-width: 8px 18px;
                    border-style: solid solid dashed solid;
                    border-color: #fdcd52;
                    border-bottom-color: transparent;
                }
            }
            .item-img {
                width: 170px;
                height: 142px;
                cursor: pointer;
            }
            .item-name {
                padding-top: 8px;
            }
            .item-op {
                position: absolute;
                right: 12px;
                top: 12px;
                display: none;
                .item-tip {
                    position: relative;
                    padding: 0 2px;
                    width: 20px;
                    height: 20px;
                    *zoom: 1;
                    background: #fff;
                    border-radius: 3px;
                    cursor: pointer;
                    border: 1px solid #D6D6D6;
                }
                .item-op-list {
                    display: none;
                    position: absolute;
                    top: 19px;
                    right: 0;
                    padding-left: 8px;
                    width: 80px;
                    background: #fff;
                    border-radius: 4px 0 4px 4px;
                    border: 1px solid #D6D6D6;
                    >div {
                        margin: 8px;
                        cursor: pointer;
                    }
                }
                &:hover {
                    .item-tip {
                        z-index: 10;
                        border-bottom-color: #fff;
                    }
                    .item-op-list {
                        display: block;
                    }
                }
            }
            &:hover .item-op {
                display: block;
            }
            .item-num {
                position: absolute;
                bottom: 34px;
                right: 12px;
                font-size: 24px;
                color: #fff;
                text-shadow: 1px 1px 1px #aaa;
            }
        }
    }
}
</style>